import { render, staticRenderFns } from "./NewUserLoginPromoDialog.vue?vue&type=template&id=3c5f0962&scoped=true"
import script from "./NewUserLoginPromoDialog.vue?vue&type=script&lang=ts"
export * from "./NewUserLoginPromoDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5f0962",
  null
  
)

export default component.exports